module.exports = __webpack_public_path__ + "static/alameda-327f529d547362f1fa01771226d2520c.jpg";